import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { SizingMultiplier, Typography } from '@ocx/ui';

export type ReferralCodeManualEntryButtonProps = {
  onClick: () => void;
};

export const ReferralCodeManualEntryButton = ({ onClick }: ReferralCodeManualEntryButtonProps) => {
  return (
    <Box
      role="button"
      onClick={onClick}
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        cursor: 'pointer',
        py: SizingMultiplier.sm,
        px: SizingMultiplier.md,
        bgcolor: 'Receipts.offerLinkBackground',
        color: 'Receipts.offerLinkColor',
        borderRadius: 2,
      }}>
      <Typography variant="body2">
        <FormattedMessage
          id="signup:referral-code-manual-entry-button:title"
          defaultMessage="Got a Referral Code? Tap Here"
        />
      </Typography>
      <ArrowCircleRightRoundedIcon sx={{ mr: -SizingMultiplier.sm }} />
    </Box>
  );
};
